var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 16,
    height: 16,
    rx: 5,
    transform: "rotate(-180 16 16)",
    fill: "#0F5CD0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1032_21787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83391 11.1667C8.8335 11.4644 8.67449 11.7392 8.41668 11.888C8.15877 12.0367 7.84118 12.0367 7.58335 11.888C7.32544 11.7392 7.16644 11.4644 7.16602 11.1667V7.41582C7.16643 7.1182 7.32544 6.84332 7.58335 6.69456C7.84116 6.5459 8.15878 6.5459 8.41668 6.69456C8.67449 6.84332 8.83349 7.1182 8.83391 7.41582V11.1667ZM8.00008 5.66789C7.7789 5.66789 7.56683 5.57995 7.41039 5.42363C7.25396 5.26721 7.16613 5.05514 7.16613 4.83394C7.16613 4.61276 7.25396 4.40069 7.41039 4.24425C7.5667 4.08794 7.77889 4 8.00008 4C8.22116 4 8.43334 4.08793 8.58967 4.24425C8.74609 4.40067 8.83393 4.61275 8.83393 4.83394C8.83393 5.05513 8.7461 5.26719 8.58967 5.42353C8.43336 5.57995 8.22117 5.66778 8.00008 5.66789Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1032_21787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.00002,
    height: 8.00002,
    fill: "white",
    transform: "translate(12 12) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.a9010ba01009be5aafa1259b1427bfcc.svg";
export { ForwardRef as ReactComponent };